import * as React from 'react';
import { connect } from 'react-redux';
import '../css/SuperUserPageView.css';
import { TooltipCont } from '../../../infrastructure/tooltips';
import { getScrollbarWidth } from '../../../lib/helpers';
import {ISeedCategory, ISeedIcon} from '../../../infrastructure/interfaces'
import HeaderBar from '../../HeaderBar/HeaderBar';
import DeleteConfirmModal from '../../Modals/DeleteConfirmModal';
import { contentImagesRelativePath } from '../../../constants';
import {getSeedIcons, createSeedIcon, toggleSeedIconPublish, editSeedIcon, deleteSeedIcon, getSeedCategories} from "../../../actions/actions";
import CreateEditSeedIconModal from "../../Modals/CreateEditSeedIconModal/CreateEditSeedIconModal"
import FilterMenu from 'src/components/FilterMenu/FilterMenu';

export interface IManageSeedIconsProps {
  seedIcons?: ISeedIcon[];
  seedCategories?: ISeedCategory[];
  editSeedIcon(seedIcon: ISeedIcon, formData?: FormData): void;
  createSeedIcon(iconName: string, category: ISeedCategory, formData?: FormData): void;
  toggleSeedIconPublish(seedIcon: ISeedIcon): void;
  deleteSeedIcon(icon: ISeedIcon): void;
  getSeedIcons(): void;
  getSeedCategories(): void;
}

export interface IManageSeedIconsState {
    showEditModal: boolean;
    showDeleteSeedIconModal: boolean;
    selectedSeedIcon?: ISeedIcon;
    categoryFilter?: String;
}

const mapStateToProps = (state: any) => {
  return {
    seedIcons: state.seedIconList,
    seedCategories: state.seedCategoryList
  };
};

const mapDispatchToProps = (dispatch: any): any => {
  return {
      getSeedIcons: () => {
          dispatch(getSeedIcons());
      },
      getSeedCategories: () => {
        dispatch(getSeedCategories());
      },
      editSeedIcon: (seedIcon: ISeedIcon, formData?: FormData) => {
        dispatch(editSeedIcon(seedIcon, formData));
      },
    createSeedIcon: (iconName: string, category: ISeedCategory, formData: FormData) => {
      dispatch(createSeedIcon(iconName, category, formData));
    },
    toggleSeedIconPublish: (seedIcon: ISeedIcon) => {
      dispatch(toggleSeedIconPublish(seedIcon));
    },
    deleteSeedIcon: (crop: ISeedIcon) => {
       dispatch(deleteSeedIcon(crop));
    },
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ManageSeedIconsTable extends React.Component<IManageSeedIconsProps, IManageSeedIconsState> {
  tableRow: HTMLElement;
  componentDidMount() {
      this.props.getSeedIcons();
      this.props.getSeedCategories();
  }

  constructor(props: IManageSeedIconsProps) {
    super(props);
    this.state = {
      showEditModal: false,
      showDeleteSeedIconModal: false,
    };
  }

  onEditSeedIcon = (seedIcon: ISeedIcon) => {

      this.setState({
          showEditModal: true,
          showDeleteSeedIconModal: false,
          selectedSeedIcon: seedIcon,
      });
  }
  onToggleSeedIconPublish = (seedIcon: ISeedIcon) => {
      this.props.toggleSeedIconPublish(seedIcon)
  }

  onDeleteSeedIconRequest(seedIcon: ISeedIcon) {
    if(seedIcon.id) {
      this.setState({
          showEditModal: false,
          showDeleteSeedIconModal: true,
          selectedSeedIcon: seedIcon,
      });
    }
  }

  onCreateSeedIcon() {
    this.setState({
        showEditModal: true,
        showDeleteSeedIconModal: false,
        selectedSeedIcon: undefined,
    });
  }

  deleteSeedIcon(seedIcon: ISeedIcon) {
    this.props.deleteSeedIcon(seedIcon);
  }

  closeModals() {

    this.setState({
      showEditModal: false,
      showDeleteSeedIconModal: false,
      selectedSeedIcon: undefined,
    });
  }

  render() {

    const {
      seedIcons,
      seedCategories
    } = this.props;
    const nonNullSeedIcons = seedIcons ? seedIcons : [];
    const sortedSeedIcons = nonNullSeedIcons.sort((a, b) => a.name.localeCompare(b.name));
    const filteredIcons = this.state.categoryFilter ? sortedSeedIcons.filter((p) => (p.category.name == this.state.categoryFilter)) : sortedSeedIcons;
    const nonNullSeedCategories = seedCategories ? seedCategories : [];

    return (
      <div className="root-container">
        <HeaderBar />
        <div className="inner-su-container">
          <div className="manage-items-row-offsetRight">

            <div className="in-row-text-container">
              Manage Trait Logos
            </div>

            <div className="in-row-button-container">
              <button
                className="btn primary-green large"
                onClick={() => {this.onCreateSeedIcon();}}
                title={TooltipCont.CREATE_COVER_PHOTO}
              >
                Upload Trait Logo
              </button>
          </div>
          </div>
          <table className="table-scrollableSU documents-table">
            <thead style={{ paddingRight: getScrollbarWidth() }}>
              <tr>
                <th>Name</th>
                <th>Image</th>
                <th>
                  <FilterMenu
                    title="Seed Category"
                    options={nonNullSeedCategories.map((p) => {
                      return { title: p.name };
                    })}
                    onFilter={(filterApplied: string) => {
                      this.setState({ categoryFilter: filterApplied });
                    }}
                  />
                </th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody className="document-table-body">
              {filteredIcons.map((s: ISeedIcon) =>
                <tr key={s.id} ref={tr => this.tableRow = tr!}>
                  <td>
                      {s.name}
                  </td>
                  <td>
                    <img className="inlineImagesTableImage" src={contentImagesRelativePath + s.src} />
                  </td>
                  <td>
                    {s.category.name}
                  </td>
                  <td>
                    <div className="button-wrapper">
                        <button
                            className="btn primary-blue"
                            onClick={() => {this.onEditSeedIcon(s)}}
                            title={TooltipCont.EDIT}
                            disabled={false}
                        >
                          Edit
                        </button>
                      <button
                        className="btn primary-red"
                        onClick={() => {this.onDeleteSeedIconRequest(s)}}
                        title={TooltipCont.DELETE}
                        disabled={false}
                      >
                        Delete
                      </button>
                    </div>
                    <div className="button-wrapper">
                      <button
                          className="btn primary-blue"
                          onClick={() => this.onToggleSeedIconPublish(s)}
                          title={TooltipCont.PUBLISH}
                          disabled={false}
                      >
                          {s.published ? "Unpublish" : "Publish"}
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>

          <CreateEditSeedIconModal
              show={this.state.showEditModal}
              seedIcon={this.state.selectedSeedIcon}
              seedCategories={nonNullSeedCategories}
              onClose={() => this.closeModals()}
              editSeedIcon={(seedIcon: ISeedIcon, formData?: FormData) => {
                  this.props.editSeedIcon(seedIcon, formData)
                  this.closeModals();
                }
              }
              createSeedIcon={(iconName: string, category: ISeedCategory, formData?: FormData) => {
                  this.props.createSeedIcon(iconName, category, formData)
                  this.closeModals();
                }
              }
          />

          <DeleteConfirmModal
              show={this.state.showDeleteSeedIconModal}
              onClose={() => this.closeModals()}
              onSave={() => {
                  if(this.state.selectedSeedIcon && this.state.selectedSeedIcon.id) {
                      this.deleteSeedIcon(this.state.selectedSeedIcon);
                  }
                  this.closeModals();
              }}
              title={(this.state.selectedSeedIcon)
                ? 'Delete Trait Logo "' + this.state.selectedSeedIcon.name + '"?'
                : 'Error. Please go back.'}
          />
        </div>
      </div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/SuperUser/components/ManageSeedIcons.tsx